import { createAction, props } from '@ngrx/store';

export const cambiarProduccion = createAction(
'[Produccion] Cambio Orden de Produccion',
props<{ produccion: Object }>()
);

export type accionesValidas = typeof cambiarProduccion;
